export default {"src":"/_next/static/media/symbol-icon-app.d2073928.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};